import React, { useMemo } from 'react';
import { FiFilePlus, FiTrash2 } from 'react-icons/fi';

import { Button, Select, Spinner } from 'common/materials';
import { SelectOption, TicketDraftSummary } from 'data/ticketCreation/schemas';

type Props = {
    drafts: TicketDraftSummary[];
    selectedDraftId?: string;
    isLoading: boolean;
    isDeleting: boolean;
    onSelect: (draftId: string) => void;
    onNew: () => void;
    onDelete: () => void;
};

function TicketDraftSelector(props: Props) {
    const { drafts, selectedDraftId, isLoading, isDeleting, onSelect, onNew, onDelete } = props;

    const draftOptions = useMemo<SelectOption[]>(
        () =>
            drafts.map(draft => ({
                value: draft.draft_id,
                label: `${draft.subject?.trim() || 'ยังไม่ระบุหัวข้อ'} · ${new Date(
                    draft.updated_on
                ).toLocaleString('th-TH')}`
            })),
        [drafts]
    );

    const selectedOption = draftOptions.find(option => option.value === selectedDraftId) ?? null;

    return (
        <div className="flex min-w-0 flex-1 flex-wrap items-center justify-end gap-2">
            <div className="flex min-w-[240px] max-w-[420px] flex-1 items-center gap-2">
                <span className="whitespace-nowrap text-sm text-neutral-600">งานร่าง</span>
                <Select<SelectOption>
                    value={selectedOption}
                    options={draftOptions}
                    placeholder={isLoading ? 'กำลังโหลดงานร่าง...' : 'เลือกงานร่าง'}
                    isDisabled={isLoading}
                    isLoading={isLoading}
                    onChange={option => option && onSelect(option.value)}
                    noOptionsMessage={() => 'ยังไม่มีงานร่าง'}
                />
            </div>

            <Button
                outline
                className="gap-1 px-3"
                disabled={isLoading}
                onClick={onNew}
            >
                <FiFilePlus />
                สร้างใหม่
            </Button>
            <Button
                outline
                className="gap-1 px-3 text-red-600"
                disabled={!selectedDraftId || isLoading || isDeleting}
                onClick={onDelete}
            >
                {isDeleting ? <Spinner /> : <FiTrash2 />}
                ลบร่าง
            </Button>
        </div>
    );
}

export default TicketDraftSelector;
